import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import {
	TooltipComponent,
	TooltipContentDirective,
} from '@valk-nx/components/ui-tooltip/src';
import { ReceiptSummaryExtraComponent } from '@valk-nx/compositions/ui-receipt-summary/src/lib/components/extra/extra.component';
import type {
	Item,
	ItemWithExtras,
} from '@valk-nx/compositions/ui-receipt-summary/src/lib/receipt-summary.interface';
import { AccommodationTypePipe } from '@valk-nx/core/lib/pipes/accommodation-type/accommodation-type.pipe';
import { CapitalizePipe } from '@valk-nx/core/lib/pipes/capitalize/capitalize.pipe';
import { PricePipe } from '@valk-nx/core/lib/pipes/price/price.pipe';

import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		AngularSvgIconModule,
		CommonModule,
		TooltipComponent,
		TooltipContentDirective,
		ReceiptSummaryExtraComponent,
		TranslatePipe,
		AccommodationTypePipe,
		PricePipe,
		CapitalizePipe,
	],
	selector: `vp-receipt-summary-item`,
	templateUrl: './item.component.html',
})
export class ReceiptSummaryItemComponent {
	item = input.required<Item | ItemWithExtras>();
	currency = input.required<string>();
	index = input.required<number>();
	totalNumberOfItems = input.required<number>();
	someItemHasExtras = input.required<boolean>();

	addedRoomCostsTotal = computed<number>(() => {
		const item = this.itemWithExtras();
		if (item) {
			if (item.additionalCharges) {
				return item.additionalCharges + item.totalPrice;
			}
			return item.totalPrice;
		}
		return 0;
	});

	itemWithExtras = computed<ItemWithExtras | undefined>(() => {
		const item = this.item();
		const hasExtras =
			'extras' in item &&
			Array.isArray(item.extras) &&
			item.extras.length > 0;
		const hasUpgrade = 'upgrade' in item && !!item.upgrade;

		return hasExtras || hasUpgrade ? (item as ItemWithExtras) : undefined;
	});
}
